import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { AnyMenuItem } from 'app/modules/Navigation/types';

import { useTranslation } from 'app/lang';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';

import { preventClick } from '../dom-utils';
import { useLeftMenuStateAPI } from '../hooks/left-menu-state-api';
import { MenuItemTestDataAttributes } from '../test-data-helpers';
import LinkContent from './LinkContent';

import styles from '../styles/LeftMenu.module.scss';

type LayerMenuItemProps = PropsWithChildren<{
  entry: AnyMenuItem;
  className?: string;
  testDataAttributes: MenuItemTestDataAttributes;
}>;

const LayerMenuItem: React.FC<LayerMenuItemProps> = ({
  className,
  entry,
  testDataAttributes,
  children,
}) => {
  const { expanded } = useLeftMenuStateAPI();
  const { t } = useTranslation();

  const linkContent = (
    <LinkContent caption={entry.caption}
                 label={entry.label}>
      {children}
    </LinkContent>
  );

  return (
    <li
      className={classNames(className, {
        [styles.active]: entry.active,
        disabled: entry.disabled,
      })}
      data-test="favorite-tournament">
      {entry.disabled ? (
        <a title={getDictionaryDataItems(t, entry.title)}
           className={styles.disabled}
           {...entry.dataGaValues}
           {...testDataAttributes}>
          {linkContent}
        </a>
      ) : (
        <Link
          to={entry.location}
          title={getDictionaryDataItems(t, entry.title)}
          onClick={expanded ? preventClick : undefined}
          tabIndex={expanded ? -1 : 0}
          {...entry.dataGaValues}
          {...testDataAttributes}>
          {linkContent}
        </Link>
      )}
    </li>
  );
};

export default LayerMenuItem;
